export const META_KEY_SHOPIFY_THEME_ID = 'gemXShopifyThemeId';
export const META_KEY_CAMPAIGN_TEMPLATE = 'gemXCampaignTemplate';
export const META_KEY_TRACKING_STATE = 'gemXTrackingState';
export const META_KEY_TRACKING_PAGE = 'gemXTrackingPage';
export const META_KEY_FEATURE_FLAG = 'gemx:feature-flag';
export const META_KEY_HEATMAP_BETA_REQUEST = 'gemx:heatmap-beta-request';

export const SHOP_META_KEY_QUERY_DEFAULT = [
  META_KEY_SHOPIFY_THEME_ID,
  META_KEY_CAMPAIGN_TEMPLATE,
  META_KEY_TRACKING_STATE,
  META_KEY_FEATURE_FLAG,
  META_KEY_HEATMAP_BETA_REQUEST,
];
